import { createContext, useContext, useState } from "react";

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ergosafe_lang") || "fr");
  const toggle = () => setLang((l) => {
    const n = l === "fr" ? "en" : "fr";
    localStorage.setItem("ergosafe_lang", n);
    return n;
  });
  const t = (fr, en) => (lang === "fr" ? fr : en);
  return <LangContext.Provider value={{ lang, toggle, t }}>{children}</LangContext.Provider>;
}
